import produce from 'immer';
import {
  UPDATE_USER,
  UPDATE_CODEOP,
  UPDATE_COUPON,
  UPDATE_QUANTITY,
  UPDATE_DETAIL,
  UPDATE_ALL_QUANTITY,
  UPDATE_TAGS_SELECT,
  UPDATE_QUANTITY_SELECT,
  ADD_INFO_TABLE,
  CANCEL,
  VALIDATION_FUNCTION,
  SELECT_PRODUCTION_ORDER,
  GENERAL_INFORMATION,
  UPDATE_EXPIRATION,
  UPDATE_PARAMETERS,
  UPDATE_PARAMETERS_CONFIG,
  UPDATE_DEMANDS,
  UPDATE_STEP,
  UPDATE_STEP_LIMIT,
  UPDATE_RESOURCES,
  DELETE_RESOURCE,
  DEMANDS_COMPLETE,
  SET_OP_LIST,
  UPDATE_INITIAL_STEP,
  SET_FABRICATION_DETAILS,
  UPDATE_FULFILLED,
} from 'src/actions/productionOrderActions';
import { v4 as uuidv4 } from 'uuid';
import { getConfig } from '@cigam/template/dist/utils/configuration';

const initialState = {
  user: '',
  step: {
    initial: getConfig(3096) ? 1 : 2,
    current: getConfig(3096) ? 1 : 2,
    limit: 3,
  },
  opList: [],
  activeOp: 0,
  op: {
    opId: 0,
    coupon: '',
    hasQuiz: false,
    liberationCode: '',
    sequence: 0,
    validBatch: false,
    initialFinalReading: false,
    changeFabricationDate: true,
    fulfilled: {
      found: false,
      message: '',
    },
    material: {
      code: '',
      description: '',
      unitMeasurement: '',
      image: '',
      integer: 0,
      decimal: 0,
    },
    tabs: {
      general: {
        quantities: {
          produced: 0,
          defect: 0,
          lost: 0,
          fulfilled: false,
        },
        details: {
          initial: new Date(),
          final: new Date(),
          batch: '',
          fabrication: new Date(),
          valid: new Date(),
        },
        total: 0,
        manufacturedQuantity: 0,
      },
      parameters: {
        operationType: {
          exit: '',
          fabrication: '',
          defect: '',
          lost: '',
        },
        storageCenter: {
          exit: '',
          fabrication: '',
          defect: '',
          lost: '',
          groupTechnology: 0,
        },
        productionOccurrences: {
          fabrication: '',
          defect: '',
          solution: '',
        },
        options: {
          confirmQuantities: getConfig(404),
          readBy: '',
        },
      },
      inspection: {},
      resources: [],
      tags: {
        tagsForm: {
          allQuantities: 0,
          activeSelect: {
            title: 'Nº de etiquetas',
            value: 'numbersTag',
          },
          select: [
            {
              title: 'Nº de etiquetas',
              value: 'numbersTag',
            },
            {
              title: 'Qtde por Etiquetas',
              value: 'qntTag',
            },
          ],
          qntValueSelect: 0,
        },
        tagsTable: [],
      },
    },
    demandsComplete: false,
  },
  validationFunction: () => true,
};

const productionOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_USER: {
      const user = action.payload;

      return produce(state, draft => {
        draft.user = user;
      });
    }

    case UPDATE_CODEOP: {
      const codeOp = action.payload;

      return produce(state, draft => {
        draft.op.opId = codeOp;
      });
    }

    case UPDATE_COUPON: {
      const coupon = action.payload;

      return produce(state, draft => {
        draft.op.coupon = coupon;
      });
    }

    case UPDATE_QUANTITY: {
      const { key, quantity } = action.payload;

      return produce(state, draft => {
        draft.op.tabs.general.quantities[key] =
          quantity <= 0 ? 0 : Number(quantity);
      });
    }

    case UPDATE_DETAIL: {
      const { key, value } = action.payload;

      return produce(state, draft => {
        draft.op.tabs.general.details[key] = value;
      });
    }

    case UPDATE_ALL_QUANTITY: {
      const quantity = action.payload;

      return produce(state, draft => {
        draft.op.tabs.tags.tagsForm.allQuantities = Math.abs(quantity);
      });
    }

    case UPDATE_TAGS_SELECT: {
      const value = action.payload;
      const { title } = initialState.op.tabs.tags.tagsForm.select.find(
        element => element.value === value
      );

      return produce(state, draft => {
        draft.op.tabs.tags.tagsForm.activeSelect.value = value;
        draft.op.tabs.tags.tagsForm.activeSelect.title = title;
      });
    }

    case UPDATE_QUANTITY_SELECT: {
      const quantity = action.payload;

      return produce(state, draft => {
        draft.op.tabs.tags.tagsForm.qntValueSelect = parseInt(
          Math.abs(quantity),
          10
        );
      });
    }

    case ADD_INFO_TABLE: {
      const { quantities, total, option } = action.payload;
      const info = [];
      switch (option) {
        case 'numbersTag':
          if (total % quantities === 0) {
            info.push({
              id: uuidv4(),
              numbersTag: quantities,
              qntTag: total / quantities,
            });
          } else {
            if (parseInt(total / quantities, 10) >= 1) {
              info.push({
                id: uuidv4(),
                numbersTag: quantities - 1,
                qntTag: parseInt(total / quantities, 10),
              });
            }
            if (
              total - parseInt(total / quantities, 10) * (quantities - 1) >=
              1
            ) {
              info.push({
                id: uuidv4(),
                numbersTag: 1,
                qntTag:
                  total - parseInt(total / quantities, 10) * (quantities - 1),
              });
            }
          }
          break;

        default:
          if (total % quantities === 0) {
            info.push({
              id: uuidv4(),
              numbersTag: total / quantities,
              qntTag: quantities,
            });
          } else {
            if (parseInt(total / quantities, 10) >= 1) {
              info.push({
                id: uuidv4(),
                numbersTag: parseInt(total / quantities, 10),
                qntTag: quantities,
              });
            }
            if (parseInt(total % quantities, 10) >= 1) {
              info.push({
                id: uuidv4(),
                numbersTag: 1,
                qntTag: parseInt(total % quantities, 10),
              });
            }
          }
          break;
      }

      return produce(state, draft => {
        draft.op.tabs.tags.tagsTable = info;
      });
    }

    case CANCEL: {
      state = initialState;
      return state;
    }

    case VALIDATION_FUNCTION: {
      const validation = action.payload;

      return produce(state, draft => {
        draft.validationFunction = validation;
      });
    }

    case SELECT_PRODUCTION_ORDER: {
      const {
        productionOrderCode,
        coupon,
        sequence,
        liberationCode,
        total,
        manufacturedQuantity,
        materialCode,
        readBy,
      } = action.payload;

      // state = { ...initialState };

      return produce(state, draft => {
        draft.op.opId = productionOrderCode;
        draft.op.coupon = coupon;
        draft.op.sequence = sequence;
        draft.op.liberationCode = liberationCode;
        draft.op.tabs.general.total = total;
        draft.op.tabs.general.manufacturedQuantity = manufacturedQuantity;
        draft.op.tabs.general.quantities.produced =
          total - manufacturedQuantity;
        draft.op.material.code = materialCode;
        draft.op.tabs.parameters.options.readBy = readBy;
      });
    }

    case SET_OP_LIST: {
      const productionOrder = action.payload;
      return produce(state, draft => {
        draft.opList = [...productionOrder];
      });
    }

    case GENERAL_INFORMATION: {
      const {
        materialDescription,
        unitMeasurement,
        materialCode,
        initialDate,
        finalDate,
        batch,
        fabricationDate,
        validDate,
        hasQuiz,
        validBatch,
        initialFinalReading,
        materialImage,
        changeFabricationDate,
        unitMeasurementInteger,
        unitMeasurementDecimal,
        fulfilledFound,
        fulfilledMessage,
      } = action.payload;

      return produce(state, draft => {
        draft.op.hasQuiz = hasQuiz;
        draft.op.validBatch = validBatch;
        draft.op.initialFinalReading = initialFinalReading;
        draft.op.changeFabricationDate = changeFabricationDate;
        draft.op.material = {
          code: materialCode,
          description: materialDescription,
          unitMeasurement,
          image: materialImage,
          integer: unitMeasurementInteger,
          decimal: unitMeasurementDecimal,
        };
        draft.op.tabs.general.details = {
          initial: initialDate,
          final: finalDate,
          batch,
          fabrication: fabricationDate,
          valid: validDate,
        };
        draft.op.fulfilled = {
          found: fulfilledFound,
          message: fulfilledMessage,
        };
      });
    }

    case UPDATE_EXPIRATION: {
      const date = action.payload;

      return produce(state, draft => {
        draft.op.tabs.general.details.valid = new Date(date);
      });
    }

    case UPDATE_PARAMETERS: {
      const { parameter, name, value } = action.payload;

      return produce(state, draft => {
        draft.op.tabs.parameters[parameter][name] = value;
      });
    }

    case UPDATE_PARAMETERS_CONFIG: {
      const {
        operationType,
        storageCenter,
        productionOccurrences,
        options,
      } = action.payload;
      return produce(state, draft => {
        draft.op.tabs.parameters = {
          operationType,
          storageCenter,
          productionOccurrences,
          options,
        };
      });
    }

    case UPDATE_DEMANDS: {
      const { produced, defect, lost } = action.payload;

      return produce(state, draft => {
        draft.op.demands = {
          produced,
          defect,
          lost,
        };
      });
    }

    case UPDATE_STEP: {
      const step = action.payload;

      return produce(state, draft => {
        draft.step.current = step;
      });
    }

    case UPDATE_STEP_LIMIT: {
      const limit = action.payload;

      return produce(state, draft => {
        draft.step.limit = limit;
      });
    }

    case UPDATE_RESOURCES: {
      return produce(state, draft => {
        draft.op.tabs.resources = action.payload;
      });
    }

    case DELETE_RESOURCE: {
      return produce(state, draft => {
        draft.op.tabs.resources.splice(action.payload, 1);
      });
    }

    case DEMANDS_COMPLETE: {
      return produce(state, draft => {
        draft.op.demandsComplete = action.payload;
      });
    }

    case UPDATE_INITIAL_STEP: {
      return produce(state, draft => {
        draft.step.initial = action.payload;
        draft.step.current = action.payload;
      });
    }

    case SET_FABRICATION_DETAILS: {
      return produce(state, draft => {
        const { changeFabricationDate, fabrication } = action.payload;

        draft.op.changeFabricationDate = changeFabricationDate;
        draft.op.tabs.general.details.fabrication = fabrication;
      });
    }

    case UPDATE_FULFILLED: {
      return produce(state, draft => {
        const { payload } = action;

        draft.op.tabs.general.quantities.fulfilled = payload;
      });
    }

    default: {
      return state;
    }
  }
};
export default productionOrderReducer;
